import React from 'react';

import { Card, Flex, Image, Popover } from 'antd-v5';
import { Paragraph, Text } from 'scouting-ui/lib';

import type { CounselorMeritBadge } from '@appTypes/esb';
import { useMBDict } from '@dict/duck/hooks';

import pageStyles from './MBCSearchPage.less';
import styles from './MBListPopover.module.scss';

interface MBListPopoverProps {
  meritBadges: CounselorMeritBadge[];
}

export function MBListPopover({ meritBadges }: MBListPopoverProps) {
  const { meritBadgesById } = useMBDict({ params: { status: 'all' } });

  const sortedBadges = [...meritBadges].sort((a, b) =>
    a.meritBadgeName.localeCompare(b.meritBadgeName),
  );

  const displayLabel = sortedBadges.map(mb => mb.meritBadgeName).join(', ');

  const popoverContent = (
    <div className={styles.popoverContent}>
      {sortedBadges.map(mb => {
        const dictMB = meritBadgesById.get(mb.meritBadgeId);
        if (!dictMB) return null;

        return (
          <Card
            key={mb.meritBadgeId}
            className={styles.badgeCard}
            size="small"
            variant="outlined"
          >
            <Flex gap="small" align="center">
              <Image
                className={styles.badgeImage}
                height={24}
                width={24}
                preview={false}
                src={dictMB.imageUrl200}
                alt={dictMB.name}
              />
              <Text font="body-overline" className={styles.badgeName}>
                {dictMB.name}
              </Text>
            </Flex>
          </Card>
        );
      })}
    </div>
  );

  return (
    <Popover trigger="hover" content={popoverContent}>
      <Paragraph
        className={pageStyles.meritBadgesList}
        ellipsis={{
          rows: 2,
          defaultExpanded: false,
        }}
      >
        {displayLabel}
      </Paragraph>
    </Popover>
  );
}
